import { createSelector } from 'reselect';
import { State } from 'reducers';
import { values, Dictionary } from 'lodash';

const getThemesState =
    (state: State) =>
        state.themes;

export const getThemes =
    createSelector(getThemesState,
        state => state.data
    );

const getThemeId = (state: State, { themeId }: Partial<{ themeId: string | null }>) => themeId;

export const getTheme =
    createSelector(
        getThemes,
        getThemeId,
        (themes, id) => (themes && id && themes[id]) || null
    );

export const getThemeDisplayName =
    createSelector(getTheme,
        theme => theme && theme.displayName
    );

export const isUploading =
    createSelector(getThemesState,
        state => !!state.uploading
    );

const getUploadState =
    createSelector(getThemesState,
        state => state.uploading
    );

export const getUploadProgress =
    createSelector(getUploadState,
        state => state && state.progress
    );

export const getUploadSuccess =
    createSelector(getUploadState,
        state => state && !!state.success
    );

export const getUploadError =
    createSelector(getUploadState,
        state => state && state.error
    );

const getScheduleState =
    createSelector(getThemesState,
        state => state.schedule
    );

export const isSchedulingTheme =
    createSelector(getScheduleState,
        state => !!state.pending
    );

export const getScheduleError =
    createSelector(getScheduleState,
        state => state.error
    );
